module.exports = __webpack_public_path__ + "img/14RorxhSF_6oAAD8aBaXr3O9e7aehiPtB.2591a198.jpg";